import { Link } from "react-router-dom";

import styles from "./NotFound.module.scss";

const NotFound = () => {
	return (
		<div className={styles.notFoundPage}>
			<div className={styles.notFoundCard}>
				<div className={styles.badge}>404</div>
				<h1 className={styles.title}>Página no encontrada</h1>
				<p className={styles.description}>
					La ruta solicitada no existe o ya no está disponible.
				</p>
				<Link to="/" className={styles.actionButton}>
					Volver al inicio
				</Link>
			</div>
		</div>
	);
};

export default NotFound;
